import classNames from 'classnames';
import { MouseEvent, useCallback } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useLogin } from '~/components/Auth';
import { useMember } from '~/components/Member/Member.hooks';
import styles from './AuthLink.module.scss';

export type AuthLinkProps = LinkProps;
export const AuthLink = ({ className, children, onClick, ...props }: AuthLinkProps) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const login = useLogin();

  const onAuthLinkClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      if (!isLoggedIn) {
        e.preventDefault();
        login();
      } else {
        onClick?.(e);
      }
    },
    [isLoggedIn, login, onClick]
  );

  return (
    <Link className={classNames(styles.root, className)} onClick={onAuthLinkClick} {...props}>
      {children}
    </Link>
  );
};
